import ReportOverview from './ReportOverview'
import React, { ReactNode } from 'react'
import BasicDetail from './BasicDetail'
import NonBankingApplicationRecords from './NonBankingApplicationRecords'
import BankApplicationRecords from './BankApplicationRecords'
import ExceptionList from './ExceptionList'
import CourtCases from './CourtCases'
import FailureComplyCases from './FailureComplyCases'
import EnforcementCases from './EnforcementCases'
import LimitHighConsumptionCases from './LimitHighConsumptionCases'
import RelatedExceptionList from './RelatedExceptionList'
import SocialTag from './SocialTag'
import LoanRecords from './LoanRecords'
import BadInformationDetection from './BadInformationDetection'
import MarriageInformation from './MarriageInformation'
import BadInformationDetailDetection from './BadInformationDetailDetection'
import TianyuanMarriageInfo from './TianyuanMarriageInfo'
import TianyuanRelationCompanyInfo from './TianyuanRelationCompanyInfo'
import TianyuanEducationInfo from './TianyuanEducationInfo'
import UdatatecMarriageInfo from './UdatatecMarriageInfo'
import TianyanchaBasicInfo from './TianyanchaBasicInfo'
import TianyanchaHolder from './TianyanchaHolder'
import TianyanchaLawSuit from './TianyanchaLawSuit'
import TianyanchaCourtAnnouncement from './TianyanchaCourtAnnouncement'
import TianyanchaDishonest from './TianyanchaDishonest'
import TianyanchaZhixinginfo from './TianyanchaZhixinginfo'
import TianyanchaAbnormal from './TianyanchaAbnormal'
import TianyanchaPunishmentInfo from './TianyanchaPunishmentInfo'
import TianyanchaIllegalinfo from './TianyanchaIllegalinfo'
import TianyanchaTaxContravention from './TianyanchaTaxContravention'
import TianyanchaAppbkInfo from './TianyanchaAppbkInfo'
import TianyanchaBids from './TianyanchaBids'
import TianyanchaCertificate from './TianyanchaCertificate'
import CompanyBankApplicationRecords from './CompanyBankApplicationRecords'
import CompanyNonBankingApplicationRecords from './CompanyNonBankingApplicationRecords'
import BbgdexRiskBlackInfo from './BbgdexRiskBlackInfo'
import BbgdexCarInfo from './BbgdexCarInfo'
import TianyanchaRelatedCompanies from './TianyanchaRelatedCompanies'
import CdDataRelationCompanyInformation from './CdDataRelationCompanyInformation'
import RongdataFailureComplyCases from './RongdataFailureComplyCases'
import RongdataLimitHighConsumptionCases from './RongdataLimitHighConsumptionCases'
import RongdataRelationCompanyInformation from './RongdataRelationCompanyInformation'
import RongdataEducationalInformation from './RongdataEducationalInformation'
import Rongdata3CLeasingRiskInformation from './Rongdata3CLeasingRiskInformation'
import RongdataEducationalSimpleInformation from './RongdataEducationalSimpleInformation'

export const getModuleName = (data: any, key: string) => {
  for (const item of data?.meta_data_module_list ?? []) {
    if (item.hasOwnProperty(key)) {
      return item[key]
    }
  }
}

export const getModuleInfo = (data: any): Array<{ key: string; name: string }> => {
  return (data?.meta_data_module_list ?? [])
    .map((item: any) => {
      const key = Object.keys(item)[0]
      const name = item[key]
      return { key, name }
    })
    .filter((item: any) => item.name && item.key !== '001')
}

export const getModuleNodes = (data: any): { nodes: ReactNode[]; finalIndex: number } => {
  let sectionCounter = 0
  const getNextIndex = () => {
    sectionCounter += 1
    return sectionCounter.toString().padStart(2, '0')
  }

  const nodes = (data?.meta_data_module_list ?? []).map((item: any) => {
    const key = Object.keys(item)[0]
    const moduleId = `module-${key}`
    switch (key) {
      case '001':
        return (
          <div key={key} id={moduleId}>
            <ReportOverview data={data} />
          </div>
        )
      case '002':
        return (
          <div key={key} id={moduleId}>
            <BasicDetail data={data} title={getModuleName(data, '002')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '003':
        return (
          <div key={key} id={moduleId}>
            <BankApplicationRecords data={data} title={getModuleName(data, '003')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '004':
        return (
          <div key={key} id={moduleId}>
            <NonBankingApplicationRecords
              data={data}
              title={getModuleName(data, '004')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case '010':
        return (
          <div key={key} id={moduleId}>
            <ExceptionList data={data} title={getModuleName(data, '010')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '018':
        return (
          <div key={key} id={moduleId}>
            <CourtCases data={data} title={getModuleName(data, '018')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '017':
        return (
          <div key={key} id={moduleId}>
            <FailureComplyCases data={data} title={getModuleName(data, '017')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '016':
        return (
          <div key={key} id={moduleId}>
            <EnforcementCases data={data} title={getModuleName(data, '016')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '015':
        return (
          <div key={key} id={moduleId}>
            <LimitHighConsumptionCases data={data} title={getModuleName(data, '015')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '011':
        return (
          <div key={key} id={moduleId}>
            <RelatedExceptionList data={data} title={getModuleName(data, '011')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '008':
        return (
          <div key={key} id={moduleId}>
            <SocialTag data={data} title={getModuleName(data, '008')} />
          </div>
        )
      case '014':
        return (
          <div key={key} id={moduleId}>
            <LoanRecords data={data} title={getModuleName(data, '014')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '009':
        return (
          <div key={key} id={moduleId}>
            <BadInformationDetection data={data} title={getModuleName(data, '009')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '012':
        return (
          <div key={key} id={moduleId}>
            <MarriageInformation data={data} title={getModuleName(data, '012')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '013':
        return (
          <div key={key} id={moduleId}>
            <BadInformationDetailDetection
              data={data}
              title={getModuleName(data, '013')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case '019':
        return (
          <div key={key} id={moduleId}>
            <BankApplicationRecords data={data} title={getModuleName(data, '019')} sectionIndex={getNextIndex()} />
          </div>
        )
      case '020':
        return (
          <div key={key} id={moduleId}>
            <NonBankingApplicationRecords
              data={data}
              title={getModuleName(data, '020')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case '021':
        return (
          <div key={key} id={moduleId}>
            <CompanyBankApplicationRecords
              data={data}
              title={getModuleName(data, '021')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case '022':
        return (
          <div key={key} id={moduleId}>
            <CompanyNonBankingApplicationRecords
              data={data}
              title={getModuleName(data, '022')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case '023':
        return (
          <div key={key} id={moduleId}>
            <CdDataRelationCompanyInformation
              data={data}
              title={getModuleName(data, '023')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyuan001':
        return (
          <div key={key} id={moduleId}>
            <TianyuanMarriageInfo data={data} title={getModuleName(data, 'tianyuan001')} />
          </div>
        )
      case 'tianyuan002':
        return (
          <div key={key} id={moduleId}>
            <TianyuanRelationCompanyInfo data={data} title={getModuleName(data, 'tianyuan002')} />
          </div>
        )
      case 'tianyuan003':
        return (
          <div key={key} id={moduleId}>
            <TianyuanEducationInfo data={data} title={getModuleName(data, 'tianyuan003')} />
          </div>
        )
      case 'udatatec001':
        return (
          <div key={key} id={moduleId}>
            <UdatatecMarriageInfo data={data} title={getModuleName(data, 'udatatec001')} />
          </div>
        )
      case 'tianyancha001':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaBasicInfo
              data={data}
              title={getModuleName(data, 'tianyancha001')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha002':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaHolder data={data} title={getModuleName(data, 'tianyancha002')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'tianyancha003':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaLawSuit data={data} title={getModuleName(data, 'tianyancha003')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'tianyancha004':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaCourtAnnouncement
              data={data}
              title={getModuleName(data, 'tianyancha004')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha005':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaDishonest
              data={data}
              title={getModuleName(data, 'tianyancha005')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha006':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaZhixinginfo
              data={data}
              title={getModuleName(data, 'tianyancha006')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha007':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaAbnormal
              data={data}
              title={getModuleName(data, 'tianyancha007')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha008':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaPunishmentInfo
              data={data}
              title={getModuleName(data, 'tianyancha008')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha009':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaIllegalinfo
              data={data}
              title={getModuleName(data, 'tianyancha009')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha010':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaTaxContravention
              data={data}
              title={getModuleName(data, 'tianyancha010')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha011':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaAppbkInfo
              data={data}
              title={getModuleName(data, 'tianyancha011')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha012':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaBids data={data} title={getModuleName(data, 'tianyancha012')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'tianyancha013':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaCertificate
              data={data}
              title={getModuleName(data, 'tianyancha013')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'tianyancha014':
        return (
          <div key={key} id={moduleId}>
            <TianyanchaRelatedCompanies data={data} title={getModuleName(data, 'tianyancha014')} />
          </div>
        )
      case 'bbgdex01':
        return (
          <div key={key} id={moduleId}>
            <BbgdexRiskBlackInfo data={data} title={getModuleName(data, 'bbgdex01')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'bbgdex02':
        return (
          <div key={key} id={moduleId}>
            <BbgdexCarInfo data={data} title={getModuleName(data, 'bbgdex02')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata001':
        return (
          <div key={key} id={moduleId}>
            <MarriageInformation data={data} title={getModuleName(data, 'rongdata001')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata002':
        return (
          <div key={key} id={moduleId}>
            <BankApplicationRecords
              data={data}
              title={getModuleName(data, 'rongdata002')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata003':
        return (
          <div key={key} id={moduleId}>
            <NonBankingApplicationRecords
              data={data}
              title={getModuleName(data, 'rongdata003')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata004':
        return (
          <div key={key} id={moduleId}>
            <EnforcementCases data={data} title={getModuleName(data, 'rongdata004')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata005':
        return (
          <div key={key} id={moduleId}>
            <CourtCases data={data} title={getModuleName(data, 'rongdata005')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata006':
        return (
          <div key={key} id={moduleId}>
            <LoanRecords data={data} title={getModuleName(data, 'rongdata006')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata007':
        return (
          <div key={key} id={moduleId}>
            <ExceptionList data={data} title={getModuleName(data, 'rongdata007')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata008':
        return (
          <div key={key} id={moduleId}>
            <RelatedExceptionList
              data={data}
              title={getModuleName(data, 'rongdata008')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata009':
        return (
          <div key={key} id={moduleId}>
            <BasicDetail data={data} title={getModuleName(data, 'rongdata009')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata011':
        return (
          <div key={key} id={moduleId}>
            <RongdataRelationCompanyInformation
              data={data}
              title={getModuleName(data, 'rongdata011')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata012':
        return (
          <div key={key} id={moduleId}>
            <RongdataLimitHighConsumptionCases
              data={data}
              title={getModuleName(data, 'rongdata012')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata013':
        return (
          <div key={key} id={moduleId}>
            <RongdataFailureComplyCases
              data={data}
              title={getModuleName(data, 'rongdata013')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata014':
        return (
          <div key={key} id={moduleId}>
            <RongdataEducationalInformation
              data={data}
              title={getModuleName(data, 'rongdata014')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata015':
        return (
          <div key={key} id={moduleId}>
            <Rongdata3CLeasingRiskInformation
              data={data}
              title={getModuleName(data, 'rongdata015')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata016':
        return (
          <div key={key} id={moduleId}>
            <RongdataEducationalSimpleInformation
              data={data}
              title={getModuleName(data, 'rongdata016')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata017':
        return (
          <div key={key} id={moduleId}>
            <CompanyBankApplicationRecords
              data={data}
              title={getModuleName(data, 'rongdata017')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata018':
        return (
          <div key={key} id={moduleId}>
            <CompanyNonBankingApplicationRecords
              data={data}
              title={getModuleName(data, 'rongdata018')}
              sectionIndex={getNextIndex()}
            />
          </div>
        )
      case 'rongdata019':
        return (
          <div key={key} id={moduleId}>
            <BbgdexRiskBlackInfo data={data} title={getModuleName(data, 'rongdata019')} sectionIndex={getNextIndex()} />
          </div>
        )
      case 'rongdata020':
        return (
          <div key={key} id={moduleId}>
            <BbgdexCarInfo data={data} title={getModuleName(data, 'rongdata020')} sectionIndex={getNextIndex()} />
          </div>
        )
      default:
        return null
    }
  })

  return { nodes, finalIndex: sectionCounter }
}
